/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(examId) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetNonDepExamBillingTimesheet: {
        $xmlns: 'http://dobs.pa.gov/tt/timesheet/bpm/1.0',
        ExamID: examId
      }
    },
    blueprintArrays: ['GetNonDepExamBillingTimesheetResponse.UsersHours.TT_TimesheetEntry'],
    blueprint: {
      userHours: [
        '$..TT_TimesheetEntry',
        {
          username: '$.Username',
          firstName: '$.FirstName',
          lastName: '$.LastName',
          totalHours: '$.TotalHours'
        }
      ],
      expenses: '$..TotalAmount',
      examHourlyRate: '$..ExamHourlyRate'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
